export default __webpack_public_path__ + "static/media/36I-102705_-17093_0.382dc011.jpg";